import { Container, Grid2 } from "@mui/material";
import React from "react";
import "./bfsiblog.scss";

const Card1 = () => {
  return (
    <Grid2 className="card1">
      <Container className="ccard">
        <h2 >Top BFSI trends for 2026 </h2>
        <p className="pg">How Salesforce is helping organizations stay ahead.</p>

        <Grid2 className="card1cont">
          <div className="incont">
            <div className="num">1</div>
            <h3>AI in Banking Becomes a Core Capability </h3>
          </div>
          <p>
            Artificial Intelligence is now central to digital transformation in
            BFSI. Financial institutions <br /> are leveraging AI to enhance
            decision-making, reduce risks, and <br />
            improve customer engagement.
          </p>
          <p className="para2">
            Salesforce Einstein, banks and financial institutions can : 
          </p>
          <Container className="boxi">
            <Grid2 className="imgb">
              <img src="/images/en.webp" alt="" />
            </Grid2>
            <div className="contb">
              <ul>
                <li>
                  Predict customer needs with <br />
                  <span>AI-driven insights </span> 
                </li>
                <li>
                  Automate lending and underwriting <span>decisions</span>
                </li>
                <li>
                  Detect fraud in <span>real time</span>{" "}
                </li>
                <li>
                  Enable <span>intelligent</span> customer interactions{" "}
                </li>
              </ul>
            </div>
          </Container>
          <Container className="ins">
            <div className="ins1">
              <h3>UTIL Insight</h3>

              <div className="inschild">
                <h4>
                  AI in banking is one of the{" "}
                  <span>fastest-growing trends</span> in BFSI.
                </h4>
              </div>
            </div>
            <div className="ins2">
              <h3>Business Impact</h3>

              <div className="inschild">
                <h4>
                  AI is transforming financial institutions into 
                  <span>data-driven, proactive organizations.</span> 
                </h4>
              </div>
            </div>
          </Container>
        </Grid2>
      </Container>
    </Grid2>
  );
};

export default Card1;
